var map = {
	"./generation_blue.png": "298b",
	"./generation_classic.png": "022a",
	"./generation_disable.png": "2986",
	"./generation_green.png": "3a46",
	"./generation_orange.png": "94d2",
	"./generation_purple.png": "caeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d862";